import "#legacy/admin/assessment_builder/_generated_templates.js";
import "#legacy/admin/assessment_builder/views/base.js";
import "#legacy/admin/assessment_builder/views/mixins/thumbnail_editor.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.SubmitterInfoForm = class SubmitterInfoForm extends (
  AssessmentBuilder.Views.Mixins.ThumbnailEditor(AssessmentBuilder.Views.Base)
) {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
    this.disableCheckboxes = this.disableCheckboxes.bind(this);
  }

  // EVENT HANDLERS

  handlePositionChange(event) {
    return this.disableCheckboxes(
      '[data-assessment-builder-behaviour="disable-unless-position"]',
      event.target.value === "none",
    );
  }

  // RENDERING

  render() {
    this.$el.html(this.template(this.selectTemplateContext(this.model.attributes, { positionItems: "position" })));
    super.render(...arguments);

    return this;
  }

  // HELPER METHODS

  disableCheckboxes(checkboxes, state) {
    return this.$(checkboxes).each(function () {
      jQuery(this).find(".check-box").attr("disabled", state);
      return jQuery(this).find("label").toggleClass("disabled", state);
    });
  }
};
AssessmentBuilder.Views.SubmitterInfoForm.prototype.tagName = "submitter-info-form";
AssessmentBuilder.Views.SubmitterInfoForm.prototype.className = "assessment-form --view-submitter-info";
AssessmentBuilder.Views.SubmitterInfoForm.prototype.template = _.template(
  AssessmentBuilder.Templates.SubmitterInfo.form,
);
AssessmentBuilder.Views.SubmitterInfoForm.prototype.editorTriggerElementSelector =
  '[data-assessment-builder-behaviour~="submitter-info-thumbnail-editor"]';

AssessmentBuilder.Views.SubmitterInfoForm.prototype.events = {
  'change sp-select[name="position"]': "handlePositionChange",
  change: "handleAttributeChange",
};
